<template>
  <v-app>
    <v-main>
    </v-main>

  </v-app>

</template>

<script lang="ts">
import {Options, Vue} from "vue-class-component";

@Options({
  components: {},
  data() {
    return {
      tab: 0,
      drawer: false,
      overlay: true,
      workshopImg: require("@/assets/main.gif"),
//      workshopImg: require("@/assets/workshop.jpg"),
      logoImg: require("@/assets/himzokucko.jpg"),
      logo1Img: require("@/assets/logo.png")
    };
  }
})
export default class HomeView extends Vue {
}
</script>

<style scoped>
.mainDiv {
  position: absolute;
  top: 0;

}

.hero-section {
  position: relative;
}

.hero-section h1 {
  font-size: 3rem;
  font-weight: bold;
}

.hero-section p {
  font-size: 1.25rem;
}
</style>
